import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const selectAll = (state: RootState) => state.featureFlags;
const selectNewSearchProductListingItemsEnabled = createSelector(
    selectAll,
    (state) => state.enableNewSearchProductListingItems,
);

const selectNewProductCardsSustainabilityInfoEnabled = createSelector(
    selectAll,
    (state) => state.enableNewProductCardsSustainabilityInfo,
);

const selectSeoMetadataOnCategoryPages = createSelector(
    selectAll,
    (state) => state.enableSeoMetadataOnCategoryPages,
);

const selectFishReportingInformationEnabled = createSelector(
    selectAll,
    (state) => state.enableFishReportingInformation,
);

const selectFullSpaModeEnabled = createSelector(selectAll, (state) => state.enableFullSpaMode);

const isFlagEnabled = (flags: RecursiveReadonly<DynamicFeatureFlag[]>, name: string): boolean => {
    const flag = flags.find((f) => f.name.toLowerCase() === name.toLowerCase());
    return !!flag?.enabled;
};

const selectAllDynamic = createSelector(selectAll, (state) => state.dynamicFeatureFlags || []);
const selectDynamicFlagEnabled = createSelector(
    selectAllDynamic,
    (_: RootState, flagName: KnownDynamicFeatureFlags) => flagName,
    isFlagEnabled,
);

const selectEveryDynamicFlagEnabled = createSelector(
    selectAllDynamic,
    (_: RootState, flagNames: KnownDynamicFeatureFlags[]) => flagNames,
    (dynamicFeatureFlags, flagNames) => {
        if (flagNames.length === 0) {
            // eslint-disable-next-line no-console
            console.warn('selectEveryDynamicFlagEnabled called with empty flagNames array');
            return false;
        }
        return flagNames.every((name) => isFlagEnabled(dynamicFeatureFlags, name));
    },
);

const selectSiteTheme = createSelector(selectAll, (state) => state.siteTheme);

export const featureFlagsSelectors = {
    selectAll,
    selectAllDynamic,
    selectDynamicFlagEnabled,
    selectEveryDynamicFlagEnabled,
    selectNewProductCardsSustainabilityInfoEnabled,
    selectFishReportingInformationEnabled,
    selectNewSearchProductListingItemsEnabled,
    selectSeoMetadataOnCategoryPages,
    selectSiteTheme,
    selectFullSpaModeEnabled,
};
